export function getFetchOptions(params) {
	if (!params) {
		params = {};
	}
	let options = {
		method: params.method || "GET",
		headers: {}
	};
	if ("contentType" in params) {
		if (params.contentType !== null) {
			options.headers["Content-Type"] = params.contentType;
		}
	}
	else {
		options.headers["Content-Type"] = "application/json";
		options.headers.Accept = "application/json";
	}
	if ("auth" in params) {
		options.headers.Authorization = "Bearer " + params.auth;
	}
	if ("body" in params) {
		if (options.headers["Content-Type"] === "application/json") {
			options.body = JSON.stringify(params.body);
		}
		else {
			options.body = params.body;
		}
	}
	return options;
}